module.exports = __webpack_public_path__ + "static/media/selected_learn.79ac7838.png";